import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./Dropdown.css";

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      selectedOption: ""
    }
  }

  handleChangeOpenState = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  displayOptions = () => {
    const options = this.props.options;
    if(this.props.defaultValue){
      options.unshift(this.props.defaultValue);
    }

    return options.map((option, index) => {
      return (

          <p key={`${option}${index}`}
          className={`option ${this.state.selectedOption ? (this.state.selectedOption === option ? "active" : null) : index === 0 ? "active" : null}`}
          onClick={() => {
            this.props.changeSelectedOption(option);
            this.setState({ selectedOption: option });
            this.handleChangeOpenState();
          }}>
          {option}
        </p>
      )
    })
  }

  render() {
    return (
      <div className="dropdown">
        <p className="selected-option" onClick={() => this.handleChangeOpenState()}>
          {this.props.selectedValue || this.state.selectedOption || (this.props.defaultValue ? this.props.defaultValue : this.props.options[0])}
        </p>
        {!this.state.isOpen && (
          <FontAwesomeIcon
            icon="caret-down"
            className="icon"
            size="sm"
            color="#59595B"
            onClick={() => this.handleChangeOpenState()}
          />
        )}
        {this.state.isOpen && (
          <FontAwesomeIcon
            icon="caret-up"
            className="icon "
            size="sm"
            color="#59595B"
            onClick={() => this.handleChangeOpenState()}
          />
        )}

        {this.state.isOpen &&
          <div className="options">{this.displayOptions()}</div>
        }
      </div>
    );
  }
}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/common/Dropdown/Dropdown.js